export default class AgeGateEnum {
    static get DISABLED() {
        return 'disabled';
    }

    static get OVER_18() {
        return 'over_18';
    }

    static get UK_CHALLENGE_25() {
        return 'uk_challenge_25';
    }

    static get US_OVER_21() {
        return 'us_over_21';
    }

    static get options() {
        return {
            DISABLED: this.DISABLED,
            OVER_18: this.OVER_18,
            UK_CHALLENGE_25: this.UK_CHALLENGE_25,
            US_OVER_21: this.US_OVER_21
        };
    }
}
